import { DentalOfficeShiftCard } from '@tempmee/react-blocks';
import { type ITodayJob } from './mapTodayJobToShiftCard';
import { useTodayShiftCard } from './useTodayShiftCard';

interface ITodayShiftCardProps {
  job: ITodayJob;
  onCardClick: (job: ITodayJob) => void;
}

/**
 * A single "Today's Professionals" shift card. Renders the DS `DentalOfficeShiftCard`
 * (no date, "current shift" state for the in-progress shift) with the shared current-shift
 * actions: the `⋯` menu (Chat / Rebook / Add-to-Favorite) and the warning-icon report flow.
 */
export const TodayShiftCard = ({ job, onCardClick }: ITodayShiftCardProps) => {
  const {
    cardData,
    menuItems,
    rebookPopup,
    onReportIncident,
    incidentReported,
    canReportIncident,
  } = useTodayShiftCard(job);

  return (
    <>
      <DentalOfficeShiftCard
        {...cardData}
        menuItems={menuItems}
        onReportIncident={onReportIncident}
        incidentReported={incidentReported}
        canReportIncident={canReportIncident}
        onCardClick={() => onCardClick(job)}
        data-cy="todays-shift-card"
      />

      {rebookPopup}
    </>
  );
};
